import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Manufacturing from "./sections/Manufacturing";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Manufacturing />
      <Footer />
    </div>;
}